import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, ViewContainerRef } from '@angular/core';
import { baseScaleIntervals } from '../../../selectionOptions';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var MinMaxScaleComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MinMaxScaleComponent, _super);
    function MinMaxScaleComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.onclose = new EventEmitter();
        _this.startScaleIntervals = tslib_1.__spread([
            {
                label: 'None',
                value: 0
            }
        ], baseScaleIntervals);
        _this.stopScaleIntervals = tslib_1.__spread([
            {
                label: 'None',
                value: 0
            }
        ], baseScaleIntervals);
        _this.registerEvent('onclose', _this.onclose);
        return _this;
    }
    Object.defineProperty(MinMaxScaleComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        set: function (value) {
            this._uniqueLayerId = value;
            if (this._uniqueLayerId) {
                this.esriLayer = this.layerService.getEsriLayerByUniqueId(this._uniqueLayerId);
                if (this.esriLayer) {
                    if (this.esriLayer.mapcoreProps.originalMinScale) {
                        this.removeLayerPreset(this.startScaleIntervals);
                        if (this.esriLayer.mapcoreProps.originalMinScale !== 0) {
                            this.addLayerPreset(this.startScaleIntervals, this.esriLayer.mapcoreProps.originalMinScale);
                        }
                    }
                    else if (typeof this.esriLayer.minScale === 'number') {
                        this.removeLayerPreset(this.startScaleIntervals);
                        if (this.esriLayer.minScale !== 0) {
                            this.addLayerPreset(this.startScaleIntervals, this.esriLayer.minScale);
                        }
                    }
                    if (this.esriLayer.mapcoreProps.originalMaxScale) {
                        this.removeLayerPreset(this.stopScaleIntervals);
                        if (this.esriLayer.mapcoreProps.originalMaxScale !== 0) {
                            this.addLayerPreset(this.stopScaleIntervals, this.esriLayer.mapcoreProps.originalMaxScale);
                        }
                    }
                    else if (typeof this.esriLayer.maxScale === 'number') {
                        this.removeLayerPreset(this.stopScaleIntervals);
                        if (this.esriLayer.maxScale !== 0) {
                            this.addLayerPreset(this.stopScaleIntervals, this.esriLayer.maxScale);
                        }
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    MinMaxScaleComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MinMaxScaleComponent.prototype.reset = function () {
        this.esriLayer.minScale = this.esriLayer.mapcoreProps.originalMinScale != undefined ? this.esriLayer.mapcoreProps.originalMinScale : 0;
        this.esriLayer.maxScale = this.esriLayer.mapcoreProps.originalMaxScale != undefined ? this.esriLayer.mapcoreProps.originalMaxScale : 0;
        this.removeLayerPreset(this.startScaleIntervals);
        if (this.esriLayer.mapcoreProps.originalMinScale !== 0) {
            this.addLayerPreset(this.startScaleIntervals, this.esriLayer.mapcoreProps.originalMinScale);
        }
        this.removeLayerPreset(this.stopScaleIntervals);
        if (this.esriLayer.mapcoreProps.originalMaxScale !== 0) {
            this.addLayerPreset(this.stopScaleIntervals, this.esriLayer.mapcoreProps.originalMaxScale);
        }
    };
    MinMaxScaleComponent.prototype.addLayerPreset = function (intervals, scaleValue) {
        var currentInterval = intervals.find(function (interval) { return (interval.value === scaleValue); });
        var changedInterval = { label: "Layer Preset - " + currentInterval.label, value: currentInterval.value };
        var currentIntervalIndex = intervals.findIndex(function (interval) { return (interval.value === scaleValue); });
        intervals[currentIntervalIndex] = changedInterval;
    };
    MinMaxScaleComponent.prototype.removeLayerPreset = function (intervals) {
        var preset = intervals.find(function (interval) { return interval.label.includes('Layer Preset'); });
        if (preset) {
            var originalInterval = baseScaleIntervals.find(function (interval) { return (interval.value === preset.value); });
            var presetIndex = intervals.findIndex(function (interval) { return (interval.value === preset.value); });
            intervals[presetIndex] = originalInterval;
        }
    };
    MinMaxScaleComponent.prototype.close = function () {
        this.onclose.emit();
    };
    return MinMaxScaleComponent;
}(BaseComponent));
export { MinMaxScaleComponent };
